<template>
	<div class="meeting-details">
		<div class="banner-show">
			<div class="cover">
				<van-swipe :autoplay="3000" indicator-color="white" :show-indicators="false">
					<van-swipe-item v-for="(item,key,index) in swiperImg" :key="index" @click="clickSwiperImg(item)">
					  <img :src="item.image" alt="">
					</van-swipe-item>
				</van-swipe>
			</div>
		</div>
		<div class="buttons">
			<div class="one">
                <img src="//xgzx.admin.talkmed.com/image/buttons/button_14.png" @click="skip(1406)"/>
            </div>
            <div class="one">
                <img src="//xgzx.admin.talkmed.com/image/buttons/button_1.png" @click="skip(1282)"/>
            </div>
            <div class="one">
                <img src="//xgzx.admin.talkmed.com/image/buttons/button_2.png" @click="skip(1342)"/>
            </div>
            <div class="one">
                <img src="//xgzx.admin.talkmed.com/image/buttons/button_3.png" @click="skip(1343)"/>
            </div>
            <div class="one">
                <img src="//xgzx.admin.talkmed.com/image/buttons/button_4.png" @click="skip(1286)"/>
            </div>
            <div class="one">
                <img src="//xgzx.admin.talkmed.com/image/buttons/button_5.png" @click="skip(1344)"/>
            </div>
            <div class="one">
                <img src="//xgzx.admin.talkmed.com/image/buttons/button_6.png" @click="skip(1283)" style="height:97%"/>
            </div>
            <div class="grid">
                <div class="half" style="text-align:center">
                    <img src="//cdn.edstatic.com/203012120000/b928c0ce1131e848e080f8da866b48db/2023/08/8dbf0815-70b4-4042-8d9c-2ce528995fec.png" style="width: 98%;" @click="skip(1285)"/>
                </div>
                <div class="half">
                    <img src="//xgzx.admin.talkmed.com/image/buttons/button_8.png" @click="skip(1345)"/>
                </div>
                <div class="half">
                    <img src="//xgzx.admin.talkmed.com/image/buttons/button_9.png" @click="skip(1407)"/>
                </div>
                <div class="half">
                    <img src="//xgzx.admin.talkmed.com/image/buttons/button_10.png" @click="skip(1348)"/>
                </div>

            </div>
            <div class="one">
                <img src="//xgzx.admin.talkmed.com/image/buttons/button_11.png" @click="skip(1349)"/>
            </div>
            <div class="one">
                <img src="//xgzx.admin.talkmed.com/image/buttons/button_12.png" @click="skip(1347)"/>
            </div>
            <div class="one">
                <img src="//xgzx.admin.talkmed.com/image/buttons/button_13.png" @click="skip(1287)"/>
            </div>

        </div>
        <img src="@/assets/images/cvscf2023/bottom.png" style="width:100%"/>
	</div>
</template>
<script>
	// import Register from "../../components/Users/Register.vue"
	import {MeetingButtons,MeetingsCarousel,MeetingsDetails,companyImages} from '../../config/interface.js'
	export default{
		data(){
			return{
				meetingButton:{},    //会议按钮
                swiperImg:[],
                meeting_id:'399'
			}
		},
		beforeRouteEnter(to, from, next) {
            //  修复iOS版微信HTML5 History兼容性问题
            if (to.path !== location.pathname) {
               
                location.assign(to.fullPath)
            } else {
                next()
            }
        },
		mounted(){
			this.getMeetingButtons(this.meeting_id);
			this.getMeetingCarousel();
            this.getMeetingDetails();
		},
		methods:{
			getImages(){
				const url=companyImages;
				let params={
					meeting_id:this.meeting_id,
				}
				const method="POST";
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						this.images=res.data;
					}
				})
			},
			//会议轮播
			getMeetingCarousel(){
				const url=MeetingsCarousel;
				let params={
					meeting_id:this.meeting_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.swiperImg=data;
					}
				})
			},
			clickSwiperImg(item){
				window.location.href=item.link;
			},
			//会议按钮
			getMeetingButtons(id){
				const url=MeetingButtons;
				const method='POST';
				let params={
					meeting_id:id
				};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						for(let i in data){
							this.meetingButton[data[i].id]=data[i].url
						}
					}
				})
			},
			//会议详情
			getMeetingDetails(){
				const url=MeetingsDetails;
				const method='POST';
				let params={
					meeting_id:this.meeting_id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						document.title=data.name;
						// this.meeting_dates=data.meeting_dates;
						//微信浏览器  请求jsdk
						if(common.is_weixin()){
							common.wxShare(data.name,data.title,data.shareimg);
						}
					}
				})
			},
            skip(id){
				if(id==1345){
					this.$router.push({
						path:'/CVSCF2023/download',
						query:{
							button_id:id
						}})
				}
				else if(id==1343){
					this.$router.push({
						path:'/CVSCF2023/hotel',
						query:{
							button_id:id
						}
					})
				}
                else if(this.meetingButton[id]){
					window.location.href=this.meetingButton[id];
                }
            }
		}
	}
</script>
<style lang="scss" scoped>
	.meeting-details{
        background: white;
		.banner-show{
			width:100%;
			// height:210px;
			padding:0px;
			.cover{
				width:100%;
				// height:210px;
				// margin-bottom:14px;
				img{
					width:100%;
					// height:210px;
				}
			}
		}
		.buttons{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding: 25px;
            .one{
                width: 32%;
            }
            .two{
                width:65%;
            }
            img{
                width: 100%;
            }
            .grid{
                width:66%;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                .half{
                    width: 48.5%;
                }
            }
        }
		
	}
</style>


// WEBPACK FOOTER //
// src/pages/CVSCF2023/index.vue